<template>
  <div class="page-container">
    <md-dialog-alert
      class="new"
      :md-fullscreen="false"
      @md-opened="scroll('locked')"
      @md-closed="scroll('clear')"
      :md-active.sync="isSuccess"
      md-content="<strong>メールアドレスを変更しました。</strong>"
    />
  </div>
</template>

<script>
import Mixin from '@/components/mixin/Mixin'
import Store from '@/store/index.js'

export default {
  name: 'Reactivate',
  mixins: [Mixin],
  data: () => ({
    isSuccess: false,
  }),
  computed: {
    token() {
      return this.$route.query.token
    },
  },
  methods: {
    update() {
      return Store.dispatch('password/changeMail', { token: this.token })
        .then(async (res) => {
          if (res.status !== 200) {
            throw new Error()
          }
          this._info('メールアドレスを変更しました。')
        })
        .catch(() => {
          this._alert(
            'メールアドレス変更期限を過ぎているか、既に変更が完了しております。'
          )
        })
    },
  },
  created: async function () {
    Store.commit('screen/create', {
      isInvisibleFilter: true,
      isLogoOnly: false,
    })
    this.spinerOn()
    await this.update()
    this.$router.push({ name: 'Login' })
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Reactivate.vue